import { marked } from "marked";
import DOMPurify from "dompurify";

export default defineNuxtPlugin({
  name: "markdown-converter",
  parallel: true,
  setup() {
    const md2html = (markdown: string): string => {
      // @ts-expect-error: Marked returns a string not a promise since this is option is not set
      return DOMPurify.sanitize(marked.parse(markdown));
    };

    return {
      provide: {
        md2html,
      },
    };
  },
});
